
import { Address, AddressAPIResponse, addressI } from './adress';
import { gendersT } from './authorization.types';
import { Communication, CommunicationAPIResponse } from './communication';
import { IdentifierAPIResponse } from './identifier';
import { dadosLoginI } from './login';
import { Qualification, QualificationAPIResponse } from './qualification';
import { TelecomAPIResponse } from './telecom';


interface Telecom {
  system: 'phone' | 'mobile' | 'email' | 'url';
  use: string;
  value: string;
}

export interface secretaryI extends dadosLoginI  { 
    id: any | null;
    identifier?: identifier[];
    name: string; 
    birthDate: string;
    gender: gendersT;
    cpf: string;
    address:  any[];
    mail: string;
    mobile?: string;
    phone?: string;
    avatar?: string;
    active: boolean;
    waiting?: boolean;
    telecom?: Telecom[];
    error?: string | undefined;
    status?: string | undefined;
    qualification: any[]; //DEFINIR CONTRATO NOVAMENTE 
    communication: any[];//DEFINIR CONTRATO NOVAMENTE 
    certificates?: qualificationI[];
    languages: any[];   
    practitioners?: number[];
}

class identifier {
  system: 'CNPJ' | 'CPF' | 'CRM';
  value: string;
  constructor(system: 'CNPJ' | 'CPF' | 'CRM', value: string) {
    this.system = system;
    this.value = value;
  }
}


export interface SecretaryInterface {

  secretaries_id: string;
  name: string;
  gender: gendersT,
  birthDate: string;
  email? : string;
  cpf: string;
  mobile?: string;
  phone?: string;
  avatar?: string;
  status: boolean;
  address?: Address;
  qualifications: Qualification[];
  certificates: Qualification[];
  communication: Communication[];
  token_id ?: string;
  photo?: string;
}

export interface SecretaryAPIResponse {

  secretaries_id: string;
  name: string;
  gender: gendersT,
  birthDate: string;
  identifier: IdentifierAPIResponse[];
  mobile?: string;
  phone?: string;
  avatar?: string;
  status: boolean;
  telecom?: TelecomAPIResponse[] | [];
  address: AddressAPIResponse[] | [];
  qualification: QualificationAPIResponse[];
  communication: CommunicationAPIResponse[];
  token_id ?: string;
  photo?: string;
}


export interface qualificationI {
  id: number;
  name: string;
  instituition?: string;
  dateConclusion?: string;
  type?: string;
}

export interface languageHL7 {
  language: string;
  preferred: boolean;
  proficiency: string;
}

export interface qualificationHLF {
  identifier: {
    system: string;
    value: string;
  }[];
  code: {
    text: string;
    type: string;
  };
  period: {
    end: string;
  };
  issuer: {
    display: string;
  };
}

export interface languageI {
  id?: number;
  name: string;
  instituition?: string;
  type?: string;
}



export const secretaryInitialState: secretaryI =  {
    id: null,
    name: '',
    birthDate: '',
    gender: 'Male',
    cpf: '',
    communication: [],
    address: [

    ],
    mail: '',
    mobile: '',
    phone: '',  
    active:true,   
    avatar: '',
    password: '',
    telecom: [],
    confirm_password: '',
    status: '',
    waiting: false,
    qualification: [],
    certificates: [],
    languages: [],
    practitioners: []

}

export const qualificationInitialState: qualificationI = {
  id: 0,
  name: '',
  instituition: '',
  dateConclusion: '',
  type: 'Bacharel',
};

export const secretaryKeys = Object.keys(secretaryInitialState);
